import { PaginatedReturnOpportunityProductListReadable } from '@crm/api'

export const getUsedUomsProduct = (
  opportunityProducts:
    | PaginatedReturnOpportunityProductListReadable
    | undefined,
  productId?: number | null,
  currentRowId?: number
) => {
  if (!opportunityProducts || !productId) return []

  return opportunityProducts.results
    .filter((p) => p.product?.id === productId && p.id !== currentRowId)
    .map((p) => p.uom?.id)
}
